import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PropTypes from 'prop-types';

export default function ButtonOptions({
	requestType,
	showEmergencyMessage,
	handleRequestTypeChange,
}) {


	return (
		<div sx={{ justifyContent: "center" }}>
			<FormControl >
				<FormLabel id="demo-radio-buttons-group-label" required>Request Type</FormLabel>
				<RadioGroup
					row
					aria-labelledby="demo-radio-buttons-group-label"
					defaultValue={requestType}
					name="radio-buttons-group"
				>
					<FormControlLabel onChange={handleRequestTypeChange} value="standard" control={<Radio required={true} />} label="Standard" />
					<FormControlLabel onChange={handleRequestTypeChange} value="emergency" control={<Radio required={true} />} label="Emergency (Need Request within 48 hours)" />
					<FormControlLabel onChange={handleRequestTypeChange} value="ccr" control={<Radio required={true} />} label="Concurrent Review" />
				</RadioGroup>
				{showEmergencyMessage && <div className="alert alert-secondary mt-2" role="alert">If not an emergency, this request will be move to the end of queue</div>}
			</FormControl>
		</div >
	);
}

ButtonOptions.propTypes = {
	requestType: PropTypes.string,
	showEmergencyMessage: PropTypes.func,
	handleRequestTypeChange: PropTypes.func,
};